export const MAIN_SIGNIN_PATH = '/signin';
export const CREATE_ACCOUNT_GA_CATEGORY = 'Create Account';
export const CREATE_ACCOUNT_FORM_ROOT_KEY = 'createAccountForm';

export const AccountType = {
    Default: 'default',
    Google: 'google',
    Facebook: 'facebook',
    Apple: 'apple',
};

export const Gender = {
    Female: 'Female',
    Male: 'Male',
};

export const passwordField = 'password';
export const emailField = 'email';
export const confirmEmailField = 'confirmEmail';
export const birthDayField = 'birthDay';
export const birthYearField = 'birthYear';
export const birthMonthField = 'birthMonth';
export const firstNameField = 'firstName';
export const lastNameField = 'lastName';
export const termsOfServiceField = 'termsOfService';
export const genderField = 'gender';
export const rememberMeField = 'rememberMe';

export const SUBMIT_MODE = {
    MODAL: 1,
    FULL: 2,
};
